<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" scrollable
                   :title="computedTitle" @show="onShow"
                   @hidden="onHidden" @ok.prevent="onSubmit" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="lot_no" type="number"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import BLUV2EditLotModelModel from "@/modules/sales/batch-lot-up-v2/BLUV2EditLotModel.model";
  import InputWidget from "@/core/components/input-widget/InputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('sales/batchLotUpV2');

  export default {
    name: "BLUV2LotEditModal",
    components: {
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        errorMessage: null,
        showConfirmation: false,
        model: new BLUV2EditLotModelModel()
      }
    },
    computed: {
      ...mapState({
        modal: state => state.lotEditModal,
        object: state => state.lotEditModal.object,
        reservedLotNos: state => state.batchLotUpV2Data.reservedLotNos,
        items: state => state.batchLotUpV2Data.items,
        maxLotNo: state => state.lotEditModal.maxLotNo,
      }),
      computedTitle() {
        if (this.object) {
          return this.$i18n.t('Edit Lot No for {stock_no}', {stock_no: this.object.stock_no})
        }
        return this.$i18n.t('Edit Lot No')
      }
    },
    methods: {
      ...mapActions(['hideLotEditModal']),
      onShow() {
        this.model.lot_no = this.object.lot_no
        this.showConfirmation = true
      },
      onHidden() {
        this.$emit('hidden')
        this.hideLotEditModal();
      },
      async onSubmit() {
        let tmpLotNo = parseFloat(this.model.lot_no)
        if (tmpLotNo % 1 !== 0) {
          this.$errorDialog('Please input valid lot number and try again')
          return false
        }

        tmpLotNo = parseInt(this.model.lot_no)
        if (this.reservedLotNos.includes(tmpLotNo)) {
          this.$errorDialog('Following lot number is reserved under sold, unsold or withdrawn lot. Please, change lot number and try again.')
          return false
        }

        if (tmpLotNo === parseInt(this.object.lot_no)) {
          this.hideLotEditModal()
          return false
        }

        if (tmpLotNo > this.maxLotNo) {
          let success = await this.$confirm(this.$i18n.t('Provided lot no is out of range. {lot_no} will be assigned instead. Do you wish to continue?', {lot_no: this.maxLotNo}))
          if (!success) {
            return false
          }

          tmpLotNo = this.maxLotNo
        }

        this.$emit('submit', {item: this.object, newLotNo: tmpLotNo})
        this.hideLotEditModal()
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
